import MobilePager from "./MobilePager"

export default MobilePager